import { xyz_n_1of4, xyz_n_DemosAndRetrospective } from './SL00000Sprint00TTR'

import { list44000Sprint05 } from '../ActivityLists/AL44000Sprint05'
import { list44000Sprint06 } from '../ActivityLists/AL44000Sprint06'

import { orderedListSlide } from './SLSprint00'
import { sprintPlanningSlideDeck } from './SLSprintPlanning'
import { insertInto } from './SL00000Sprint00TTR'
import { checklistAnnouncementsPreworkAndAgenda } from './SL00000Sprint00'
import { completeDeck } from './SL00000Sprint00'
import { tRecap } from './SLSprint00'	
import { tPrework } from './SLSprint00'
import { submissionPercentage } from './SLSprint00'

import { xyz_n_1of4_PAaA, xyz_n_4of4_PAaA, xyz_n_4of4 } from './SL00000Sprint00TTR'

// Shared slides across multiple sprint 6 class sections.
export const sprintPlanningExpectations = () => {
		return orderedListSlide('Sprint Planning', `Sprint ${sprint} Expectations:`, [
			'Similar to other sprints with Discussion, Lab, and Reflection',
			`Similar in that we will have Lab $${sprint} - Planning due Thursday`,
			`Similar in that we will set aside time for Quiz ${sprint} next Tuesday`,
			`Similar in that we will have two weeks to complete all sprint ${sprint} assignments`,
			`Similar in that we will have sprint ${sprint-1} Demos and Retrospectives on Thursday`,
			`Similar in that we will complete on Discussion Board ${sprint} as a scrum team in class on Thursday`,
			`Similar in that we will complete your team’s Sprint ${sprint} Planning in class today`,
	])
}

// Software Engineering (SE) sprint 6 global values.
const sprint = 6
const activityList = () => { return list44000Sprint06(sprint) }
const activityListPrevious = () => { return list44000Sprint05(sprint-1) }
const sprintAndActivityLists = { 'sprint': sprint, 'activityList': activityList, 'activityListPrevious': activityListPrevious }

// Session 1 of 4: Tuesday
const se_6_1of4 = () => { 
	const slideDeck = xyz_n_1of4(null, null, sprintAndActivityLists, sprintPlanningExpectations) 
	const insertAfterRecap = 8
	return insertInto(slideDeck, sprintPlanningSlideDeck(sprint), insertAfterRecap+1)
}

const se_6_2of4_PAaA = {
	'prework':[
		'Complete through activity 4',
		'Be prepared for Demos and Retrospectives' ],
	'announcements':[ 
		`Lab ${sprint} - Planning and Discussion ${sprint} initial post are due today`, '',
	],
	'agenda':[
		`Sprint ${sprint} Demos and Retrospectives`,
		`Sprint ${sprint} Planning and Discussion ${sprint}`
	],
}
const se_6_2of4 = () => { 
	const preworkNext = () => { return tPrework('Prework For Next Class', se_6_3of4_PAaA.prework, sprint, activityList) }
	const recap = () => { return tRecap(se_6_2of4_PAaA.agenda) }

	const slideDeck = checklistAnnouncementsPreworkAndAgenda(se_6_2of4_PAaA, sprint, activityList)
	const completeDeckResult = completeDeck(slideDeck, [ preworkNext, recap ])
	return insertInto(completeDeckResult, sprintPlanningSlideDeck(sprint), 5)
}

// Session 3 of 4: Tuesday
const se_6_3of4_PAaA = {
	'prework':[
		'Complete through activity 5',
		'Be prepared for Demos and Retrospectives' ],
	'announcements':[ 
		`Any announcements?`, '',
	],
	'agenda':[
		`Sprint ${sprint-1} Demos`,
		`Sprint ${sprint-1} Retrospective`,
		`Breakout for Sprint ${sprint-1} Retrospective`,
		'Prework for Next Class',
		'Lab',
		`Quiz ${sprint}` ],
}

const se_6_3of4 = () => { 
	const metricsSubmissionPercentage = () => {
		return submissionPercentage([
			{ name: 'Discussion', due:24, submitted:24 },
			{ name: 'Quiz', due:24, submitted:24 },
			{ name: 'Lab', due:24, submitted:24 },
			{ name: 'Reflection', due:24, submitted:24}])
	}
	const retrospective = () => {
			return orderedListSlide('Class Retrospective',
				'Feedback from Assignments & Reflections', [
				`Incredible submission percentage in sprint ${sprint-1}`,
				`All sprint ${sprint-1} assignments were submitted by all students in the class`, 
				'We were missing one Lab 1 - Planning submission, but I am going to let that slide (never done that before)',
				'How would we like to celebrate... my daughter is certain that we need “Tessi Day”' ])
	}	

	return xyz_n_DemosAndRetrospective(se_6_3of4_PAaA, se_6_4of4_PAaA, sprintAndActivityLists, metricsSubmissionPercentage, retrospective)
}

export const se_6_4of4_PAaA = {
	'prework':[
		'Complete through activity 6', '',
		'Be prepared for Lab' 
 ],
	'announcements':[ 
		`All sprint ${sprint} announcements due Sunday`, 
		`Monday is Sprint ${sprint} Planning`
	],
	'agenda':[
		'Lab'
	],
}

const se_6_4of4 = () => { 
	return xyz_n_4of4(xyz_n_4of4_PAaA(5, sprint), xyz_n_1of4_PAaA(sprint+1), sprintAndActivityLists ) 
}

export const se_6_slidedeckTTR = [ se_6_1of4, se_6_2of4, se_6_3of4, se_6_4of4 ]